import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
const mixin = {
    mixins: [validationMixin],
    validations: {
        title: {
            required,
        },
        content: {
            required,
        },
    },
    computed: {
        titleErrors() {
            const errors = [];
            if (!this.$v.title.$dirty) return errors;
            !this.$v.title.required && errors.push("タイトルを入力してください。");
            return errors;
        },
        contentErrors() {
            const errors = [];
            if (!this.$v.content.$dirty) return errors;
            !this.$v.content.required && errors.push("詳細を入力してください。");
            return errors;
        },
    },
};

export default mixin;